export default "__VITE_ASSET__5eddddc1__"